import { useDispatch, useSelector } from 'react-redux';
import { hideStepSkeleton } from '../utils/functions';
import { useOptionsType } from '../utils/types';
import { useEffect, useMemo } from 'react';

export function useOptions({
  attribute,
  labels,
  autoSkip,
  parentSelections,
}: {
  attribute: string;
  labels?: { [key: string]: string };
  autoSkip?: boolean;
  parentSelections?: any;
}): useOptionsType {
  const dispatch = useDispatch();
  const insuranceLoading = useSelector(
    (state: any) => state.insurance.insuranceLoading.isLoading
  );
  const insuranceEnabled = useSelector(
    (state: any) => state.insurance.insuranceEnabled
  );

  const currentStepKey = window.rxcBrain.currentStep?.key;

  const [options, onSelect] = useMemo(() => {
    const [options, onSelect] = window.rxcBrain.getOptions({
      attribute,
      labels,
      autoSkip,
      dispatch,
      parentSelections,
    });
    setTimeout(() => hideStepSkeleton(), 200);
    return [options, onSelect];
  }, [attribute, parentSelections, insuranceLoading]);

  // get insurance prices
  useEffect(() => {
    if (
      insuranceEnabled &&
      options &&
      options.length &&
      !window.rxcBrain.hideCurrentStep
    ) {
      // Non chiamiamo l'insurance nello step delle transition o del colore perché all'interno di color_picker e swatch_list c'è già la gestione corretta

      if (
        currentStepKey !== 'LensColour' &&
        currentStepKey !== 'LensTransitionColor' &&
        currentStepKey !== 'LensTreatmentDetail' &&
        attribute !== 'color'
      ) {
        console.log('chiamata a ria - attribute: ', attribute);
        window.rxcBrain.getInsurancePrices(dispatch);
      }
    }
  }, [
    attribute,
    currentStepKey,
    insuranceEnabled,
    options,
    window.rxcBrain.hideCurrentStep,
  ]);

  return [options, onSelect];
}
